// extracted by mini-css-extract-plugin
module.exports = {"count":"CharCount_count___eUAu","over":"CharCount_over__by89l"};